import { v4 as uuidv4 } from 'uuid';

const STORAGE_KEY = 'vertexai_user_pseudo_id';
const MAX_LENGTH = 128;

export const getUserPseudoId = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing && existing.length <= MAX_LENGTH) {
      return existing;
    }

    const id = uuidv4();
    localStorage.setItem(STORAGE_KEY, id);

    return id;
  } catch {
    return undefined;
  }
};
